import $rdf from '@zazuko/env/web.js';
import { rdf, sh } from '@tpluscode/rdf-ns-builders';
import { isGraphPointer } from 'is-graph-pointer';
export class TargetClass {
    constructor(classes) {
        this.classes = classes;
    }
    buildPatterns({ focusNode, variable }) {
        if (isGraphPointer(this.classes)) {
            const typeQuad = $rdf.quad(focusNode, rdf.type, this.classes.term);
            return {
                constructClause: [typeQuad],
                whereClause: [{
                        type: 'bgp',
                        triples: [typeQuad],
                    }],
            };
        }
        const classVariable = variable();
        const typeQuad = $rdf.quad(focusNode, rdf.type, classVariable);
        const values = this.classes.terms.map(term => ({ ['?' + classVariable.value]: term }));
        return {
            constructClause: [typeQuad],
            whereClause: [{
                    type: 'bgp',
                    triples: [typeQuad],
                }, {
                    type: 'values',
                    values,
                }],
        };
    }
}
TargetClass.property = sh.targetClass;
